import { render } from "./Slide.vue?vue&type=template&id=1f216e56&scoped=true&ts=true"
import script from "./Slide.vue?vue&type=script&lang=ts"
export * from "./Slide.vue?vue&type=script&lang=ts"

import "./Slide.vue?vue&type=style&index=0&id=1f216e56&scoped=true&lang=css"
import "@/assets/about.css?vue&type=style&index=1&id=1f216e56&lang=css&scoped=true"
import "@/assets/nicepage.css?vue&type=style&index=2&id=1f216e56&lang=css&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f216e56"]])

export default __exports__